<!--Copy right - © 2024 tecera gmbh-->
<!-- LoginForm.svelte -->
<script>
    import { Link } from "svelte-routing";
    import {
        login,
        login_info_message,
        login_error_message,
    } from "../../scripts/auth.js";
    import { navigate } from "svelte-routing";
    import { onDestroy, onMount } from "svelte";

    let username = "",
        password = "";
    let submit_button, form, autofocus_input; // Identity of components
    let is_loading = false; // Bool for displaying loading spinner

    onMount(() => {
        autofocus_input.focus();
    });
    onDestroy(() => {
        $login_info_message = null;
        $login_error_message = null;
    });

    // form submit function
    async function handle_submit(event) {
        is_loading = true;
        $login_error_message = null;
        $login_info_message = null;
        event.preventDefault(); // prevent autosubmit so form wont get cleared and make wrong http request
        if (form.checkValidity()) {
            // check if all inputfields in form are valid
            const response = await login(username, password);
            if (response.status === "error") {
                $login_error_message = response.message;
            } else if (response.status === "success") {
                is_loading = false;
                navigate("/hydranten");
            }
        } else {
            form.reportValidity();
        }
        is_loading = false;
    }
</script>

<form class="form-signin" style="padding-left: 5px;padding-right:5px;" on:submit={handle_submit} bind:this={form}>
    <!-- Logo-->
    <img
        src="img/NEXT_Suite_Login_Logo.svg"
        alt="NEXT_Suite_Login_Logo"
    />
    <p class="login-headline">Login</p>

    <!-- Warning message -->
    {#if $login_error_message}
        <div class="alert alert-warning" role="alert">
            <i class="fa-solid fa-triangle-exclamation"
            ></i>&nbsp;&nbsp;{$login_error_message}
        </div>
    {:else if $login_info_message}
        <div class="alert alert-info" role="alert">
            <i class="fa-solid fa-circle-info"
            ></i>&nbsp;&nbsp;{$login_info_message}
        </div>
    {/if}

    <!-- Input - Username -->
    <div class="input-group login-input">
        <div class="icon-container">
            <i class="fa fa-user login-icon"></i>
        </div>
        <input
            bind:this={autofocus_input}
            bind:value={username}
            type="email"
            id="username"
            class="form-control login-input ml-2 pl-2"
            style="border:none; margin-bottom:-1px"
            placeholder="E-Mail"
            required
            autocomplete="username"
            maxlength="64"
        />
    </div>

    <!-- Input - Password -->
    <div class="input-group login-input">
        <div class="icon-container">
            <i class="fa fa-lock login-icon"></i>
        </div>
        <input
            bind:value={password}
            type="password"
            id="password"
            class="form-control login-input ml-2 pl-2"
            style="border:none; margin-bottom:-1px"
            placeholder="Passwort"
            autocomplete="current-password"
            required
            maxlength="64"
        />
    </div>

    <div
        style="display:flex;flex-direction:column;justify-content:space-between;"
    >
        <button
            bind:this={submit_button}
            type="submit"
            class="btn btn-lg btn-primary btn-block mb-4"
            style="font-size: 18px; font-weight: 550; display: flex; justify-content: center; align-items: center;"
        >
            {#if is_loading}
                <div
                    id="loader"
                    class="loader_small"
                    style="position:relative"
                />
            {:else}
                <div>Anmelden&nbsp;<i class="fa fa-sign-in"></i></div>
            {/if}
        </button>

        <div class="login-row">
            <Link
                class="btn btn-link "
                to="/register"
                style="font-size: 1rem; font-weight: 550; white-space: wrap;"
            >
                Registrieren
            </Link>
            <Link
                class="btn btn-link "
                to="/reset_password"
                style=" font-size: 1rem; font-weight: 550;white-space: wrap;"
            >
                Passwort vergessen?
            </Link>
        </div>
    </div>
</form>
